import React from "react";
import {
  cardExpiryBadgeClasses,
  cardExpiryBadgeLabel,
  cardExpiryStatus,
} from "../../utils/cardExpiry";

interface CardExpiryBadgeProps {
  expMonth: unknown;
  expYear: unknown;
  className?: string;
}

/**
 * "Expires soon" (amber) or "Expired" (red) beside a saved card. Renders
 * nothing for a card that is fine or whose date cannot be read. The rule is
 * utils/cardExpiry (end of the expiry month, on the club's calendar).
 */
const CardExpiryBadge: React.FC<CardExpiryBadgeProps> = ({ expMonth, expYear, className = "" }) => {
  const status = cardExpiryStatus(expMonth, expYear);
  const label = cardExpiryBadgeLabel(status);
  if (!label) return null;
  return (
    <span
      data-testid="card-expiry-badge"
      className={`inline-block px-2 py-0.5 text-xs font-semibold rounded-full ${cardExpiryBadgeClasses(status)} ${className}`}
    >
      {label}
    </span>
  );
};

export default CardExpiryBadge;
